"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stringifyObject = stringifyObject;
var _isObject = require("./isObject");
/**
 * This is just copied https://www.npmjs.com/package/stringify-object and slightly modified. All props to them.
 */
const {
  propertyIsEnumerable
} = Object.prototype;
const {
  toString
} = Object.prototype;
function isRegexp(value) {
  return toString.call(value) === '[object RegExp]';
}
function getOwnEnumerableKeys(object) {
  return [...Object.keys(object), ...Object.getOwnPropertySymbols(object).filter(key => propertyIsEnumerable.call(object, key))];
}
function stringifyObject(inputValue, leftPad = '', oneLineOnly) {
  const seen = [];
  const indent = '   ';

  // eslint-disable-next-line complexity -- copied from other library
  return function stringify(input, pad = '') {
    const tokens = {
      newline: oneLineOnly ? ' ' : '\n',
      newlineOrSpace: oneLineOnly ? ' ' : '\n',
      pad,
      indent: oneLineOnly ? '' : pad + indent
    };
    if (seen.includes(input)) {
      return '"[Circular]"';
    }
    if (typeof input === 'function') {
      return `"[Function ${input.name || 'anonymous'}]"`;
    }
    if (typeof Buffer !== 'undefined' && input instanceof Buffer) {
      return '"[Buffer]"';
    }
    if (input === null || input === undefined || typeof input === 'number' || typeof input === 'boolean' || typeof input === 'symbol' || isRegexp(input)) {
      return String(input);
    }
    if (input instanceof Date) {
      return `new Date('${input.toISOString()}')`;
    }
    if (Array.isArray(input)) {
      if (input.length === 0) {
        return '[]';
      }
      seen.push(input);
      const returnValue = `[${tokens.newline}${input.map((element, i, elements) => {
        const eol = elements.length - 1 === i ? tokens.newline : `,${tokens.newlineOrSpace}`;
        const value = stringify(element, pad + indent);
        return tokens.indent + value + eol;
      }).join('')}${tokens.pad}]`;
      seen.pop();
      return returnValue;
    }
    if ((0, _isObject.isObject)(input)) {
      const objectKeys = input instanceof Error ? Object.getOwnPropertyNames(input) : getOwnEnumerableKeys(input);
      if (objectKeys.length === 0) {
        return '{}';
      }
      seen.push(input);
      const returnValue = `{${tokens.newline}${objectKeys.map((element, index) => {
        const eol = objectKeys.length - 1 === index ? tokens.newline : `,${tokens.newlineOrSpace}`;
        const isSymbol = typeof element === 'symbol';
        const isClassic = !isSymbol && /^[a-z$_][$\w]*$/i.test(element);
        const key = isSymbol || isClassic ? element : stringify(element, undefined);
        const value = stringify(input[element], pad + indent);
        return `${tokens.indent + String(key)}: ${value}${eol}`;
      }).join('')}${tokens.pad}}`;
      seen.pop();
      return returnValue;
    }
    let output = input.replace(/\\/g, '\\\\');
    output = String(output).replace(/[\r\n]/g, x => x === '\n' ? '\\n' : '\\r');
    return `"${output.replace(/"/g, '\\"')}"`;
  }(inputValue, leftPad);
}
//# sourceMappingURL=stringifyObject.js.map